// extracted by mini-css-extract-plugin
module.exports = {"column":"column-module--column--y94Al","inner":"column-module--inner--18tvv"};